export const NUDGGE_API_BASE_URL =
  import.meta.env.VITE_NUDGGE_API_BASE_URL ?? 'https://api-nudgge.taplylab.com'

export const nudggeFunctionUrl = (path) => {
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${NUDGGE_API_BASE_URL}${normalized.startsWith('/functions/v1') ? '' : '/functions/v1'}${normalized}`
}
